/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSpendByCloudWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostSpendByCloudWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostSpendByCloudWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostSpendByCloudWidgetConfiguration>): CostSpendByCloudWidgetConfiguration {
        let obj = Object.assign(new CostSpendByCloudWidgetConfiguration(), model);
        CostSpendByCloudWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSpendByCloudWidgetConfiguration>): CostSpendByCloudWidgetConfiguration {
        if (!model) return null;
        return CostSpendByCloudWidgetConfiguration.newInstance(<CostSpendByCloudWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSpendByCloudWidgetConfiguration) {
        if (!obj) return;

        models.CostSpendByCloudWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSpendByCloudWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostSpendByCloudWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
